import { ReactElement, useMemo } from "react";
import { CommunityPostListItem } from "../../../Items/CommunityPostListItem";
import { TimeZone } from "client/DateAndTime/timezones";
import { generateTrackingId, isNotNil } from "client/Misc/utils";
import { convertUserIdentityModel } from "client/Features/Search/RecentSearch/Persistence/convertPersistedData";
import { UserIdentityModel } from "client/Api/UserProfile/service";
import { GlobalSearchResultItemKind } from "client/Api/TitleBar/GlobalSearch/globalSearch";
import { GlobalSearchItem } from "../../../GlobalSearchItem/GlobalSearchItem";
import { useCommunityPostNavigationHandler } from "../../../Navigation/useCommunityPostNavigationHandler";
import { ValidGlobalSearchItemPersistedModel } from "client/Features/Search/RecentSearch/Persistence/validation";

export type CommunityPostItemViewProps = {
	item: ValidGlobalSearchItemPersistedModel<GlobalSearchResultItemKind.CommunityPost>;
	itemIndex: number;
	onRemove: () => void;
	timezone: TimeZone;
	tabIndex: number;
};

export const CommunityPostItemView = (props: CommunityPostItemViewProps): ReactElement => {
	const {
		item,
		itemIndex,
		onRemove,
		timezone,
		tabIndex
	} = props;

	const {
		id,
		communityName,
		createdBy: persistedCreatedBy,
		createdOn,
		messagePreview
	} = item.communityPost;

	const createdBy = useMemo(
		(): UserIdentityModel | null => isNotNil(persistedCreatedBy)
			? convertUserIdentityModel(persistedCreatedBy)
			: null,
		[persistedCreatedBy]
	);

	const openHandler: () => void = useCommunityPostNavigationHandler({
		id,
		recentlyOpenedItem: item
	});

	return (
		<GlobalSearchItem
			trackingId={generateTrackingId("community-post-item", `|${id}`)}
			onClick={openHandler}
		>
			<CommunityPostListItem
				id={id}
				communityName={communityName}
				createdBy={createdBy}
				createdOn={createdOn}
				messagePreview={messagePreview}
				onRemove={onRemove}
				timezone={timezone}
				itemIndex={itemIndex}
				tabIndex={tabIndex}
				onExecute={openHandler}
			/>
		</GlobalSearchItem>
	);
};
CommunityPostItemView.displayName = "CommunityPostItemView";